"use client";  

import dynamic from "next/dynamic";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Carousel = dynamic(() => import("../components/carousel/Carousel"), {
    ssr: false,
    loading: () => (
      <Skeleton 
        height="80vh" 
        width="90vw"
      />
    ),
  });
  
  

export default function LazyCarousel({ blogs }: { blogs: any }) {
  return <Carousel blogs={blogs} />;
}
